import Reveal from './Reveal';

export default function SectionHeading({ eyebrow, title, description, align = 'center' }) {
  const alignment = align === 'left' ? 'text-left items-start' : 'text-center items-center mx-auto';

  return (
    <Reveal className={`flex max-w-2xl flex-col gap-4 ${alignment}`}>
      {eyebrow && <span className="section-eyebrow">{eyebrow}</span>}
      <h2 className="text-3xl font-bold tracking-tight text-ink dark:text-white sm:text-4xl">{title}</h2>
      {description && <p className="text-base leading-relaxed text-muted dark:text-subtle">{description}</p>}
    </Reveal>
  );
}
